export const PRODUCT_TYPES_SINGULAR = {
  pillow: 'pillow',
  mattress: 'mattress',
  bedFrames: 'bed_frames',
  sheets: 'sheet',
  bedding: 'bedding',
  defaultProductName: 'product',
};

const productTypeToSingularProductNameMatching = {
  pillows: PRODUCT_TYPES_SINGULAR.pillow,
  mattresses: PRODUCT_TYPES_SINGULAR.mattress,
  bed_frames: PRODUCT_TYPES_SINGULAR.bedFrames,
  sheets: PRODUCT_TYPES_SINGULAR.sheets,
  bedding: PRODUCT_TYPES_SINGULAR.bedding,
  defaultProductName: PRODUCT_TYPES_SINGULAR.defaultProductName,
} as const;

export const productTypeToSingularProductNameConverter = (
  productType: keyof typeof productTypeToSingularProductNameMatching,
  productCategory?: { name: string }[],
): string => {
  if (productType === 'bedding' && productCategory) {
    const beddingType =
      productCategory[productCategory.length - 1]
        .name.toLowerCase() as keyof typeof productTypeToSingularProductNameMatching;
    return (
      productTypeToSingularProductNameMatching[beddingType] ||
      productTypeToSingularProductNameMatching.defaultProductName
    );
  }
  if (
    !Object.keys(productTypeToSingularProductNameMatching).includes(productType)
  ) {
    return productTypeToSingularProductNameMatching.defaultProductName;
  }

  return (
    productTypeToSingularProductNameMatching[productType] ||
    productTypeToSingularProductNameMatching.defaultProductName
  );
};
